export interface Expense {
  id: string;
  title: string; // ناوی خەرجی
  description: string; // وەسف
  amount: number; // بڕ
  currency: "IQD" | "USD"; // دینار یان دۆلار
  category: string; // جۆر
  date: string; // بەروار
  notes: string; // تێبینی
  createdAt: Date;
}

export const EXPENSE_CATEGORIES = [
  "کرێی دوکان",
  "کارەبا",
  "ئاو",
  "ئینتەرنێت",
  "مووچە",
  "گواستنەوە",
  "چاککردنەوە",
  "کڕینی کەلوپەل",
  "هەر شتێکی تر",
] as const;
